/**
 * 根路径
 */
export const basePath = '/certification';

/**
 * 环境host
 */
export const directPrefix = {
  prod: 'https://ssosv.sankuai.com/sson/login',
  staging: 'http://ssosv.it.st.sankuai.com/sson/login',
  test: 'http://ssosv.it.test.sankuai.com/sson/login',
  dev: 'http://ssosv.it.test.sankuai.info/sson/login',
  local: 'http://localhost:8080/sson/login'
}[DEPLOY_ENV];

// 账户类型
export enum EEmpolyeeType {
  PERSON = 1, // 美团正式员工
  INTERN = 2, // 美团实习生
  PARTTIME = 3, // 兼职
  PARTTIME_NEW = 4, // 非PS兼职,
  VIRTUAL = 5, // 虚拟帐号
  SYS = 6, // 系统用户
  DCAGENT = 7, // 到餐代理商
  DZAGENT = 8, // 到综代理商
  LSAGENT = 9, // 零售代理商
  DDAGENT = 10, // 点餐代理商
  WAGENT = 11, // 外卖代理商
  GWAGENT = 12, // 客服代理商
  SYAGENT = 13, // 收银代理商
  BMAGENT = 20, // 配送代理商
  JRAGENT = 22, // 金融代理商
  JWAGENT = 23, // 境外代理商
  Other = -1, // 其他用户
}

export const reqAuthCode = {
  passkey: {
    /**
     * passkey认证成功
    */
    success: 4560001
  },
  sms: {
    /**
     * 短信认证成功
    */
    success: 4560003,
    /**
     * 短信发送频繁
    */
    frequent: 1050003,
    /**
     * 短信发送成功
    */
    smsSendSuccess: 1050000
  },
};
